(function () {
  var SEC = '[id$="__usp_row"]';
  var mq = window.matchMedia('(max-width: 749px)');
  /* 05.10.2026: "Bewegung reduzieren" -> kein Auto-Wechsel, kein weiches Scrollen */
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var sec = document.querySelector(SEC);
    if (!sec) return;
    var track = sec.querySelector('.section-content-wrapper.mobile-column');
    if (!track || track.dataset.wzUsp) return;
    var items = track.querySelectorAll(':scope > .group-block');
    if (items.length < 2) return;
    track.dataset.wzUsp = '1';

    var dots = document.createElement('div');
    dots.className = 'wz-usp-dots';
    for (var i = 0; i < items.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Vorteil ' + (i + 1));
      (function (idx) { b.addEventListener('click', function () { go(idx, true); }); })(i);
      dots.appendChild(b);
    }
    track.parentNode.insertBefore(dots, track.nextSibling);
    var dotEls = dots.querySelectorAll('button');

    var current = 0, timer = null, paused = false, held = false, pauseT = null, st = null;

    function setActive(idx) {
      current = idx;
      for (var j = 0; j < dotEls.length; j++) {
        dotEls[j].classList.toggle('is-active', j === idx);
        if (j === idx) dotEls[j].setAttribute('aria-current', 'true');
        else dotEls[j].removeAttribute('aria-current');
      }
    }
    function go(idx, manual) {
      if (idx < 0) idx = items.length - 1;
      if (idx >= items.length) idx = 0;
      var target = track.scrollLeft + (items[idx].getBoundingClientRect().left - track.getBoundingClientRect().left);
      track.scrollTo({ left: target, behavior: rm.matches ? 'auto' : 'smooth' });
      setActive(idx);
      if (manual) pauseAwhile();
    }
    function next() { go(current + 1); }
    function start() {
      stop();
      if (mq.matches && !rm.matches) timer = setInterval(function () { if (!paused && !held) next(); }, 3800);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function pauseAwhile() {
      paused = true;
      clearTimeout(pauseT);
      pauseT = setTimeout(function () { paused = false; }, 6000);
    }

    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var best = 0, bestDist = Infinity, tl = track.getBoundingClientRect().left;
        for (var k = 0; k < items.length; k++) {
          var d = Math.abs(items[k].getBoundingClientRect().left - tl);
          if (d < bestDist) { bestDist = d; best = k; }
        }
        setActive(best);
      }, 90);
    }, { passive: true });

    track.addEventListener('pointerdown', pauseAwhile, { passive: true });

    /* Anhalten, solange Maus oder Tastaturfokus im Slider ist (WCAG 2.2.2) */
    var wrap = track.parentNode;
    wrap.addEventListener('mouseenter', function () { held = true; });
    wrap.addEventListener('mouseleave', function () { held = false; });
    wrap.addEventListener('focusin', function () { held = true; });
    wrap.addEventListener('focusout', function () { held = false; });

    setActive(0);
    start();

    var onChange = function () { stop(); if (mq.matches) { go(0); start(); } };
    if (mq.addEventListener) { mq.addEventListener('change', onChange); rm.addEventListener('change', onChange); }
    else if (mq.addListener) { mq.addListener(onChange); rm.addListener(onChange); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target || e.target.id.indexOf('usp_row') !== -1) init();
  });
})();
